// extracted by mini-css-extract-plugin
export var content = "_bh-3";
export var list = "_bh-4";
export var settingsContent = "_bh-7";
export var settingsPanel = "_bh-8";
export var state = "_bh-6";
export var triggerBadge = "_bh-2";
export var triggerButton = "_bh-1";
export var triggerShell = "_bh-0";
export var unreadDot = "_bh-5";